export const capitalizeFirstLetter = (string) => {
  const newString = string.replace(/[-]/g, ' ');
  return newString && newString[0].toUpperCase() + string.slice(1);
};

export const capitalizeSQL = (string) => {
  return string.replace('sql', 'SQL');
};

export const extraFormat = (string) => {
  return string?.replace('bigquery', 'BigQuery');
};
